import React from 'react'
import resolveProps from '../../utils/resolveProps'

const config = {
  types: [],
  modifiers: ['gutters', 'alignItems', 'justifyContent'],
  states: []
}

export default function Row(props) {
  const { children, ...rest } = props
  return (
    <div {...rest} className={resolveProps(props, config, 'Row')}>
      {children}
    </div>
  )
}
